import omitBy from "lodash/omitBy"
import isUndefined from "lodash/isUndefined"
import { parse, stringify } from "query-string"
import moment from "moment"

const CARDS_PER_PAGE = 10

export const getRows = (totalCount, page) => {
    let startRow = null
    let endRow = 9

    if (totalCount && +totalCount > CARDS_PER_PAGE && +page > 1) {
        startRow = page * CARDS_PER_PAGE - CARDS_PER_PAGE
        endRow = page * CARDS_PER_PAGE - 1

        if (endRow >= totalCount) endRow = totalCount
    }

    return { startRow, endRow }
}

export const formatBookingQueries = query => {
    const {
        s: searchQuery,
        y: yachtQuery,
        from: fromQuery,
        to: toQuery,
        r: routeQuery,
        g: guestsQuery,
        cname: customerNameQuery,
        sortBy,
        sortOrder,
        page,
        totalCount
    } = query

    const { startRow, endRow } = getRows(totalCount, page)

    const paramsObj = {
        searchString: searchQuery,
        vesselIds: yachtQuery.length ? yachtQuery : undefined,
        routeIds: routeQuery.length ? routeQuery : undefined,
        guests: guestsQuery,
        customerName: customerNameQuery,
        from: fromQuery,
        to: toQuery ? moment(toQuery).add(1, "days").format("YYYY-MM-DD") : fromQuery,
        sortBy,
        sortOrder,
        startRow,
        endRow
    }

    return omitBy(paramsObj, isUndefined)
}

export const stringifyQueries = (name, value, location) => {
    const search = { ...parse(location.search), [`${name}`]: value }
    return stringify(search)
}
